import axios from '../Backend';


export const updateUserMe = async (data = {}) => {
    try {
        const res = await axios.patch(`/users/me`, data);
        const resData = res.data
        return resData
    } catch (e) {
        console.log('updateUserMe :: Error')
        console.log(JSON.stringify(e))
        if (e.response) {
            console.log('updateUserMe :: Response Error')
            console.log(JSON.stringify(e.response.data))
        }
        throw e
    }
}

export const getAgents = async () => {
    try {
        const res = await axios.get(`/company/getAgents`);
        const resData = res.data
        return resData
    } catch (e) {
        if (e.response?.data) {
            console.log('getAgents :: Response Error', e.response.data)
        }
        else {
            console.log('getAgents :: Error', e)
        }
        throw e
    }
}